import { render, staticRenderFns } from "./MainSlidesDialog.vue?vue&type=template&id=b82c319e&"
import script from "./MainSlidesDialog.vue?vue&type=script&lang=js&"
export * from "./MainSlidesDialog.vue?vue&type=script&lang=js&"
import style0 from "./MainSlidesDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports